import {
  LanguagesDocument,
  type WhereLanguageInput,
} from '~~/graphql/operations'
import { BaseSelect } from '../model'

export class LanguageSelect extends BaseSelect {
  override name = 'languageId'
  override label = 'Language'
  override placeholder = 'Select language'

  override options(query, where: WhereLanguageInput) {
    const merged: WhereLanguageInput = {
      ...(query && query.length ? { name: { contains: query } } : {}),
      ...(where || {}),
    }
    return this.optionsQuery(LanguagesDocument, 'languages', {
      variables: {
        where: Object.keys(merged).length ? merged : undefined,
      },
    })
  }
  override async initialOptions(ids: any[], where) {
    return this.optionsQuery(LanguagesDocument, 'languages', {
      variables: {
        where: {
          ...where,
          id: ids?.length
            ? {
                in: ids.map(Number),
              }
            : undefined,
        },
      },
    })
  }
}
